import { Accordion } from '@iwoca/orion';

import styles from './DocRequirementsDE.module.css';

export const DocRequirementsDE = () => {
  return (
    <Accordion
      small
      title="Folgende Unterlagen brauchen wir für die jeweiligen Kredithöhen"
      className={styles.accordion}
    >
      <>
        <h2>1.000 € - 50.000 €</h2>
        <ul>
          <li>Kontoumsätze Ihres Geschäftskontos der letzten 90 Tage</li>
        </ul>

        <h2>50.001 € - 500.000 €</h2>

        <ul>
          <li>Kontoumsätze Ihres Geschäftskontos der letzten 90 Tage</li>
          <li>BWA und SuSa der letzten beiden Geschäftsjahre</li>
          <li>Aktuelle BWA und SuSa (nicht älter als 4 Monate)</li>
        </ul>

        <h2>Tipps</h2>
        <ul>
          <li>EÜR ersetzen die BWA</li>
          <li>Jahresabschlüsse ersetzen BWA und SuSa</li>
        </ul>
      </>
    </Accordion>
  );
};
